<template>
  <div v-if="show" class="modal-overlay" tabindex="-1" aria-labelledby="loginModalLabel">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="loginModalLabel">Login</h5>
        </div>
        <form @submit.prevent="login">
          <div class="modal-body">
            <!-- Mostra il messaggio di errore -->
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
            <div class="mb-3">
              <label for="username" class="form-label">Username</label>
              <input
                type="text"
                class="form-control"
                id="username"
                autocomplete="username"
                v-model="loginForm.username"
                required
              />
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input
                type="password"
                class="form-control"
                id="password"
                autocomplete="current-password"
                v-model="loginForm.password"
                required
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary">Login</button>
            <button type="button" class="btn btn-secondary" @click="closeModal">Chiudi</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/authStore";

export default {
  name: "ModalLogin",
  props: {
    show: Boolean,
    handleLogin: Function,
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    authStore() {
      return useAuthStore();
    },
    errorMessage() {
      return this.authStore.errorMessage; // Collega il messaggio di errore dallo store
    },
  },
  methods: {
    async login() {
      try {
        await this.handleLogin(this.loginForm); // Passa i dati del form
        this.$emit("update:show", false); // Chiudi la modale se il login ha successo
      } catch (error) {
        console.error("Errore durante il login:", error.message);
      }
    },
    closeModal() {
      this.$emit("update:show", false); // Chiude la modale
    },
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1010;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
}
</style>